
var Acr = Acr || {};

Acr.SocialGrid = function () {

  var utility = window.Utility;

  var $body;
  var $socialGrid;
  var $socialCardsSlider;
  var $socialModalSlider;
  var $socialModalVideo;
  var $socialModal;
  var resizeTimer;
  var showDots;
  var showArrows;
  var slidesToShow;
  var slidesToScroll;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $socialGridSwiper;
  var $socialGridSwiperContainer;
  var $swiperSlide;

  const focusableElements = 'button, [href]:not(.modal-cta), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const selectorAnchorVideo = '[href], svg.js-play-video';
  const selectorModalVisible = '.js-social-modal.visible';
  const swiperSlideActiveSelector = '.swiper-slide.swiper-slide-active';
  const modalOverlaySelector = '.acr-social-modal__overlay';
  const socialModalCloseSelector = '.acr-icon.acr-social-modal__close';

  let focusableEls = document.querySelectorAll(focusableElements);
  let firstFocusableEl = focusableEls[0];
  let lastFocusableEl = focusableEls[focusableEls.length - 1];

  function initSocialGridSwiper() {
    let navigation = false;
    let pagination = false;
    if ($socialGrid.classList.contains('social-grid--look-2') || $socialGrid.classList.contains('social-grid--look-3')) {
      if ($arrowLeft && $arrowRight) {
        Utility.removeClass('hide', $arrowLeft);
        Utility.removeClass('hide', $arrowRight);
      }
    }
    if ($socialGrid.classList.contains('social-grid--look-3')) {
      slidesToShow = 1.5;
      slidesToScroll = 1;
    } else {
      slidesToShow = 3;
      slidesToScroll = 3;
    }

    if (showArrows) {
      navigation = {
        nextEl: $arrowRight,
        prevEl: $arrowLeft,
      };
    }
    if (showDots) {
      pagination = {
        el: $swiperPagination,
        clickable: true,
      };
    }
    $socialGridSwiper = new Swiper($socialGridSwiperContainer, {
      slidesPerView: 1,
      watchSlidesVisibility: true,
      centeredSlides: false,
      loop: true,
      pagination: pagination,
      navigation: navigation,
      init: true,
      breakpoints: {
        550: {
          slidesPerView: slidesToShow,
        },
      },
      on: { 
        init: function () {
          setTabIndex();
        },
      },
    });

    $socialGridSwiper.on('click', function (event) {
      let goToSingleSlide = this.clickedSlide.dataset.swiperSlideIndex;
      if ($socialModal) {
        openHandler(goToSingleSlide);
      }
    });
    $socialGridSwiper.$el.on('keydown', function (event) {
      if (event.keyCode !== 13 && event.keyCode !== 32) return;
      let goToSingleSlide = event.target.dataset.swiperSlideIndex;
      if ($socialModal) {
        openHandler(goToSingleSlide);
      }
    });

    $socialGridSwiper.on('slideChange', function () {
      setTabIndex();
      if (Acr.TrackingManager && event.type === 'click') {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
  }

  function setTabIndex() {
    $swiperSlide.forEach(function (element) {
      if (element.classList.contains('swiper-slide-visible')) {
        element.setAttribute('tabindex', '0');
      } else {
        element.removeAttribute('tabindex');
      }
    });
  }

  function attachEnters() {
    $socialModal.querySelector(socialModalCloseSelector).removeEventListener('keydown', function (e) { if (e.key === 'Enter') closeHandler(); });
    $socialModal.querySelector(socialModalCloseSelector).addEventListener('keydown', function (e) { if (e.key === 'Enter') closeHandler(); });

    $socialModal.querySelectorAll('.js-play-video').forEach(function (el) {
      el.removeEventListener('keydown', function (e) { if (e.key === 'Enter') playVideo(e); });
      el.addEventListener('keydown', function (e) { if (e.key === 'Enter') playVideo(e); });
    });
  }

  function attachClicks() {

    $socialModal.querySelector(socialModalCloseSelector).removeEventListener('click', closeHandler);
    $socialModal.querySelector(socialModalCloseSelector).addEventListener('click', closeHandler);

    $socialModal.querySelector(modalOverlaySelector).removeEventListener('click', closeHandler);
    $socialModal.querySelector(modalOverlaySelector).addEventListener('click', closeHandler);

    $socialModal.querySelector(modalOverlaySelector).removeEventListener('click', stopPropagation);
    $socialModal.querySelector(modalOverlaySelector).addEventListener('click', stopPropagation);

    $socialModal.querySelectorAll('.js-play-video').forEach(function (el) {
      el.removeEventListener('click', playVideo);
      el.addEventListener('click', playVideo);
    });

    if ($socialModalVideo) {
      $socialModalVideo.forEach(function (el) {
        el.removeEventListener('ended', resetVideo);
        el.addEventListener('ended', resetVideo);
      });
    }
  }

  function openHandler(slideToGo) {
    // Disable scrolling.
    document.addEventListener('touchmove', handleTouchLock, { passive: false });
    $body.classList.add('modal-open');

    $socialModal.classList.add('visible');
    $socialModal.focus();

    setModalHeight();
    setModalSwiper(slideToGo);
  }

  var trapFocus = function (e) {
    var isTabPressed = e.key === 'Tab' || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.style['-ms-user-select'] = 'text';
        lastFocusableEl.focus();
        lastFocusableEl.style['-ms-user-select'] = '';
        e.preventDefault();
      }
    } if (!e.shiftKey) {
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.style['-ms-user-select'] = 'text';
        firstFocusableEl.focus();
        firstFocusableEl.style['-ms-user-select'] = '';
        e.preventDefault();
      }
    }
  };

  function closeHandler() {
    const currrentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector);
    // Enable scrolling.
    document.removeEventListener('touchmove', handleTouchLock);
    $socialModal.classList.remove('visible');
    $body.classList.remove('modal-open');
    $socialModalSlider.destroy(true, true);
    resetVideoSlide(currrentModalSlideElem, true);
  }

  function playVideo(event) {
    let $videoButton = event.currentTarget;
    let $video = Utility.prev(event.currentTarget, '.js-video');
    if (window.getComputedStyle($video, null).getPropertyValue('display') === 'none') {
      $video = Utility.prev($video, '.js-video');
    }

    if ($video) {
      $video.play();
      $videoButton.style.display = 'none';
    }
  }

  function resetVideo(event) {
    event.target.parentElement.querySelector('.js-play-video').style.display = 'block';
    if (document.activeElement.classList.contains('modal-open')) {
      $socialModal.querySelector(swiperSlideActiveSelector).querySelector('svg.js-play-video').focus();
      event.preventDefault();
    }
    // shows the video poster after the video ends
    const videoUrl = event.target.currentSrc;
    event.target.src = '';
    event.target.src = videoUrl;
  }

  function resetVideoSlide(slide, force) {
    let videos;
    if (slide.querySelectorAll('.js-video').length > 0) {
      slide.querySelectorAll('.js-video').forEach(function (el) {
        if (el.offsetWidth > 0 && el.offsetHeight > 0) {
          videos = [el];
        }
      });
    }
    if (force) {
      videos = [...slide.querySelectorAll('.js-video')];
    }

    if (videos) {
      videos.map(function (video, index) {
        if (!video.paused) {
          const videoUrl = video.currentSrc;
          video.src = '';
          video.src = videoUrl;
        }
      });
    }

    let video = slide.querySelector('.js-play-video');
    if (video) {
      video.style.display = 'block';
    }
  }

  function setModalHeight() {
    let windowHeight = document.body.getBoundingClientRect().height;
    let modalPadding = 100; // Modal should have 50px of padding-top and 50px of padding-bottom
    let imgHeight = $socialModal.querySelector('.acr-social-modal__content-container .acr-social-modal__media-container').getBoundingClientRect().height;

    if (utility.isMobile()) {
      let headerHeight = $socialModal.querySelector('.acr-social-modal__header.header--mobile').height;
      $socialModal.querySelector('.acr-social-modal__content').innerHeight = windowHeight - headerHeight - imgHeight - modalPadding;
    } else {
      $socialModal.querySelector('.acr-social-modal__content').innerHeight = imgHeight;
    }
  }

  function setModalSwiper(slideToGo) {
    $socialModalSlider = new Swiper($socialModal.querySelector('.swiper-container'), {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: $socialModal.querySelector('.js-arrow-right'),
        prevEl: $socialModal.querySelector('.js-arrow-left'),
      },
      initialSlide: parseInt(slideToGo, 10),
      on: {
        init: function () {
          const currentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector).querySelectorAll(selectorAnchorVideo);
          disableTabOnSlides();
          currentModalSlideElem.forEach(function (el) {
            el.setAttribute('tabindex', '0');
          });
          updateFocusableElements();
        },
      },
    });

    function disableTabOnSlides() {
      const elementsToDisable = $socialModal.querySelectorAll(selectorAnchorVideo);
      elementsToDisable.forEach(function (el) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('focusable', 'false');
      });
    }

    function updateFocusableElements() {
      focusableEls = document.querySelector(selectorModalVisible).querySelectorAll(focusableElements);
      focusableEls.forEach(function (element) {
        element.removeAttribute('focusable');
      });
      firstFocusableEl = focusableEls[0];
      lastFocusableEl = focusableEls[focusableEls.length - 1];
    }

    $socialModalSlider.on('transitionEnd', function () {
      $socialGridSwiper.slideToLoop($socialModalSlider.realIndex);
    });

    $socialModalSlider.on('slideChange', function () {
      const currentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector);
      resetVideoSlide(currentModalSlideElem);
      if (Acr.TrackingManager) {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });

    $socialModalSlider.on('slideChangeTransitionEnd', function () {
      disableTabOnSlides();
      const currentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector).querySelectorAll(selectorAnchorVideo);
      currentModalSlideElem.forEach(function (el) {
        el.setAttribute('tabindex', '0');
      });
      updateFocusableElements();
    });

    attachClicks();
    attachEnters();
    executeLazyLoading();
  }

  function stopPropagation(e) {
    e.stopPropagation();
  }

  function handleTouchLock(e) {
    e.preventDefault();
  }


  function attachKeyboardInput() {
    document.removeEventListener('keyup', keyboardHandler);
    document.addEventListener('keyup', keyboardHandler);
  }

  function keyboardHandler(e) {
    if (e.which === 27 && $socialModal.classList.contains('visible')) { // esc key
      closeHandler();
    }
  }

  function attachResize() {
    window.addEventListener('resize', function (e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!$socialModal.classList.contains('visible') && $socialModalSlider) {
          $socialModalSlider.destroy(true, true);
        }
        if ($socialModal.length && $socialModal.classList.contains('visible')) {
          const currrentModalSlideElem = $socialModal.querySelector(swiperSlideActiveSelector);

          setModalHeight();

          resetVideoSlide(currrentModalSlideElem);
        }
      }, 250);
    });
  }

  function executeLazyLoading() {
    var videosToLoad = [].slice.call(document.querySelectorAll('.swiper-slide video.lazy'));
    Utility.initLazyLoadingIO(videosToLoad, Acr.LazyLoadingHelper.loadVideo);
  }

  // This function initializes the selectors and the data attributes required in other functions
  function initSelectors(element) {
    $body = document.body;
    $socialGrid = element;
    $socialCardsSlider = $socialGrid.querySelector('.js-social-cards-slider');
    $socialModal = Utility.next($socialGrid, '.js-social-modal');
    showDots = ($socialCardsSlider.dataset.showDots === 'true');
    showArrows = ($socialCardsSlider.dataset.showArrows === 'true');
    $swiperPagination = $socialGrid.querySelector('.js-swiper-pagination');
    $arrowLeft = $socialGrid.querySelector('.js-arrow-left');
    $arrowRight = $socialGrid.querySelector('.js-arrow-right');
    $socialGridSwiperContainer = $socialGrid.querySelector('.swiper-container');
    $swiperSlide = $socialGrid.querySelectorAll('.swiper-slide');

    if ($socialModal) {
      $socialModalVideo = $socialModal.querySelectorAll('.js-video');
      var closeElement = $socialModal.querySelector(socialModalCloseSelector);
      if (closeElement) {
        closeElement.setAttribute('tabindex', '0');
      }
      $socialModal.removeEventListener('keydown', trapFocus);
      $socialModal.addEventListener('keydown', trapFocus);
    }
  }

  function init(element) {
    initSelectors(element);
    initSocialGridSwiper();
    attachClicks();
    attachKeyboardInput();
    attachResize();
    executeLazyLoading();
  }

  return {
    init: init,
  };
};
